/* eslint-disable no-underscore-dangle */
const _require = require('../lib/evaluateSource'),
  evaluateSource = _require.evaluateSource;

/**
  * @function evalute - evaluate containsStatusBehavior
  *
  * this returns true if the value passed in
  * the `contains` parameter matches any
  * status in the statusHistory of the content.
  */

const evaluate = async (format, content, parentContentPath, transientContext, nativeFunctions) => {
  const _content$statusHistor = content.statusHistory,
    statusHistory = _content$statusHistor === void 0 ? {} : _content$statusHistor;
  const values = Object.values(statusHistory);
  if (values.length === 0) {
    return undefined;
  }
  const contains = await evaluateSource(format.contains, content, parentContentPath, transientContext, nativeFunctions);
  if (contains === undefined || typeof contains !== 'string') {
    return undefined;
  }
  return values.find(status => status.status.toLowerCase() === contains.toLowerCase()) !== undefined;
};
module.exports = {
  evaluate
};